import HelpdeskWidget from '@/components/helpdesk/HelpdeskSelector';
import { Outlet } from 'react-router-dom';

export const HelpdeskLayout = () => {
  return (
    <>
      <Outlet />
      <HelpdeskWidget />
    </>
  );
};
